export const ROUTE = Object.freeze({
  CHATBOT: "chatbot",
  HOME: "home",
  LOGIN: "login",
  PASSWORD_RESET: "password-reset",
  PROJECTS: "projects",
  PROJECT: "project",
  CUSTOMERS: "customers",
  CUSTOMER: "customer",
  RESULTS: "view-results",
  USERS: "users",
  LOOKUPS: "lookups",
  AG_GRID_EXPERIMENT: "ag-grid-experiment",
  DOCUMENT_EXTRACT: "document-extract",
  PROJECT_EXTRACT: "project-extract",
});

export const VALID_ROUTES = [ROUTE.LOGIN, ROUTE.PASSWORD_RESET, ROUTE.HOME, ROUTE.PROJECTS, ROUTE.PROJECT, ROUTE.CUSTOMERS, ROUTE.CUSTOMER, ROUTE.CHATBOT, ROUTE.USERS, ROUTE.RESULTS, ROUTE.LOOKUPS, ROUTE.AG_GRID_EXPERIMENT, ROUTE.DOCUMENT_EXTRACT, ROUTE.PROJECT_EXTRACT] as const;

export const VALID_ROUTES_WITH_ID = [ROUTE.PROJECT, ROUTE.CUSTOMER, ROUTE.RESULTS, ROUTE.DOCUMENT_EXTRACT, ROUTE.PROJECT_EXTRACT] as const;

export type ValidRoute = (typeof VALID_ROUTES)[number];
export type ValidRouteWithId = (typeof VALID_ROUTES_WITH_ID)[number];
